import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MatTableModule, MatTableDataSource } from "@angular/material/table";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WindowRef } from "../../utils/window";
import { TranslateUtil } from "../../utils/translate-util";
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { Banner } from "../../shared/models/banner";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { SharedTranslateModule } from "../../../../src/app/utils/sharedTranslateModule";
import { AuthorizationService } from '../authorization/authorization.service';
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";

@Component({
  selector: "div.dtf-adminfunctions",
  standalone: true,
  imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, MatInputModule,SessionTimeoutComponent, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule],
  templateUrl: "./adminfunctions.component.html",
})
export class AdminFunctionsComponent implements OnInit {

  alerts: Banner[] = [];
  tableLoaded = true;
  successMessage: string = '';
  dataSource = new MatTableDataSource<Banner>(this.alerts);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private windowRef: WindowRef,
    public translateUtil: TranslateUtil,
    public dtfhomepageService: DTFHomepageService,
    public auth: AuthorizationService
  ) {
    this.router = router;
    this.alerts = [];
    this.dataSource = new MatTableDataSource<Banner>(this.alerts);
  }

  initColumns: any[] = [
    { name: 'bannerType', display: 'Banner Type', dispFormat: ''},
    { name: 'bannerCountry', display: 'Country', dispFormat: ''},
    { name: 'bannerHeader', display: 'Banner Header', dispFormat: 'editable'},
    { name: 'bannerCopy', display: 'Banner Copy', dispFormat: 'editablecopy'},
    { name: 'bannerEnable', display: 'Banner Enabled', dispFormat: 'editable'},
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  ngOnInit(): void {
    this.loadAlerts();
  }

  private loadAlerts(): void {
    this.tableLoaded = false; // Show loading spinner
    this.dtfhomepageService.getAlertsAdmin().subscribe({
      next: (res: Banner[]) => {
        this.alerts = res;
        this.dataSource.data = res; 
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.tableLoaded = true; // Hide loading spinner
      },
      error: (err) => {
        console.error("Failed to load alerts", err);
      }
    });
  }

  saveData() {
  this.dataSource._updateChangeSubscription();

  const updatedData = this.dataSource.data;
  console.log('Saving data:', updatedData);

  this.auth.saveBannerData(updatedData).subscribe({
    next: (res) => {
      console.log('Data saved successfully', res);

      this.successMessage = 'Changes have been saved successfully.';
      
      // Optional: auto-hide after 3 seconds
      setTimeout(() => {
        this.successMessage = '';
      }, 3000);
    },
    error: () => {
      this.successMessage = 'Something went wrong while saving.';
    }
  });
}
}